import { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigContext } from "../../context/config";
import { getDataforProfilePageApi } from "../../Network/network";
import {
  setFollowFormData,
  setUpdateProfileStateRedux,
} from "../../reducers/auth/action";
import useIdentity from "../../utils/identity";
import Iframe from "../iframe/Iframe.component";
import Spinner from "../spinner/Spinner.component";
import FollowCard from "./FollowCard";

export default function StepThree({ followData, loading }) {
  const { deso } = useSelector((state) => state.auth);

  const [followApi, setFollowApi] = useState([]);
  const { followApiState, setFollowApiState } = useContext(ConfigContext);
  const [followApiLoading, setFollowApiLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setUpdateProfileStateRedux({
        loading: false,
        step: null,
      })
    );
  }, []);

  useEffect(() => {
    setFollowApiLoading(true);
    if (deso?.user) {
      fetchProfileData();
    }
  }, [deso?.user]);

  let bodyData = {
    public_key: deso?.user?.publicKeyAdded,
    jwt: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2MTk2NDk4MDcsImV4cCI6MTYxOTY0OTg2N30.FKZF8DSwwlnUaW_eRa7Wr1v2QcG7_iDN-NjdqXUcgrSAPg1EdSfpWsLL4GeUiD9zdLUgrNoKU7EsKkE-ZKMaVQ",
  };
  const fetchProfileData = async () => {
    const res = await getDataforProfilePageApi(bodyData);
    setFollowApi(res?.common_following);
    setFollowApiLoading(false);
  };

  return loading || followApiLoading ? (
    <Spinner />
  ) : (
    <>
      <div className="pb-[30px]">
        <Iframe />
        <p className="text-[18px] pt-[16px] text-[#161616] md:pb-[40px] pb-[32px]">
          Find some people that pique your interest and follow them.
        </p>
        <div className=" md:grid sm:grid-cols-1 md:grid-cols-2 gap-6 follow_content_list  overflow-x-hidden">
          {followData?.map((data, index) => {
            let publicKey = deso?.user?.publicKeyAdded;
            let unfollow = true;
            // follow functionality
            const handleFollow = (value) => {
              let fromData = new FormData();
              fromData.append("public_key", publicKey);
              fromData.append("is_unfollow ", value);
              fromData.append("user_to_follow ", data?.public_key);

              dispatch(setFollowFormData(fromData));
              if (followApiState) {
              } else {
                setFollowApiState(true);
              }

              setTimeout(() => {
                if (value) {
                  setFollowApi(
                    followApi?.filter((item) => item !== data?.public_key)
                  );
                } else {
                  setFollowApi([...followApi, data?.public_key]);
                }
                unfollow = value;
                setFollowApiState(false);
              }, 1000);
            };
            const checkUnfollow = () => {
              const findItem = followApi?.find(
                (item) => item === data?.public_key
              );
              if (findItem === data?.public_key) {
                unfollow = false;
              }
              return unfollow;
            };
            checkUnfollow();

            return (
              <div key={index} className="px-3 py-[8px] md:pb-0">
                <div className="flex justify-between ">
                  <div className="flex items-center">
                    <img
                      className="w-[48px] h-[48px]"
                      src={data?.profile_pic_url}
                      alt=""
                    />
                    <div className="ml-[16px]">
                      <h5 className="text-[20px] font-bold hidden lg:inline">
                        {data?.username}
                      </h5>
                      <h5 className="text-[20px] font-bold lg:hidden">
                        {data?.username?.slice(0, 10).concat("...")}
                      </h5>
                    </div>
                  </div>
                  <button
                    onClick={() => handleFollow(!unfollow)}
                    className={`${
                      unfollow
                        ? " border-[#B9B9B9] bg-white"
                        : "bg-[#DDE0FF] border-[#575975]"
                    } border  text-blue rounded-[8px] w-[112px] md:h-[48px] h-[40px] hover:bg-[#EEEFFF]`}
                  >
                    {unfollow ? " Follow " : "Following"}
                  </button>
                </div>
                <div>
                  <p className="mt-[16px]">
                    {data?.description?.slice(0, 200).concat("...")}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
